<mat-card
  class="app-card"
  appearance="outlined"
  [class.app-card--disabled]="app().status === 'NOT_PERMITTED'"
>
  <mat-card-content>
    <div class="app-card__content">
      <div class="app-card__avatar">
        <claas-icon
          namespace="cc"
          iconId="648466"
          iconStyle="bold"
          [size]="40"
          alt=""
          [removeDefaultColor]="true"
        />
      </div>
      <span class="app-card__title">{{ app().title }}</span>
    </div>

    @if (app().status === "ACTIVE") {
      <claas-icon-button
        class="app-card__favorite"
        [ariaLabel]="
          isFavorite() ? 'Remove from favorites' : 'Add to favorites'
        "
        [icon]="favoriteIcon()"
        [iconSize]="iconButtonSize.SMALL"
        (click)="toggleFavorite()"
      />

      <div class="app-card__actions">
        @if (app().readMoreLink) {
          <a
            class="app-card__read-more"
            [href]="app().readMoreLink"
            target="_blank"
            rel="noopener noreferrer"
            >Details</a
          >
        }
        @if (app().link) {
          <claas-button
            class="app-card__open"
            [buttonClass]="buttonClass.PRIMARY"
            size="small"
            (click)="openApp()"
            >{{ app().buttonText || "Open" }}</claas-button
          >
        }
      </div>
    }
  </mat-card-content>
</mat-card>
